import {Injector, APP_INITIALIZER} from '@angular/core';
import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {AppTranslateModule} from '@app/core/i18n/app-translate.module';
import {i18nAppInitializer} from '@app/core/i18n/i18n.initializer';
import {I18nService} from '@app/core/services/i18n.service';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {PortalDefaultRedirectComponent} from '@app/core/components/portal-default-redirect.component';
import {SharedModule} from '@shared/shared.module';
import {AuthService} from "@app/core/services/auth.service";
import {IdempotencyInterceptor, LanguageInterceptor, RequestInterceptor, TokenInterceptor} from "@app/core/interceptors";
import {StoreInvitationModule} from "@app/features/store-invitation/store-invitation.module";
import {AgmCoreModule} from "@agm/core";
import {environment} from "@environments/environment";
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from "@angular/common/http";
import {NgxSpinnerModule} from "ngx-spinner";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {AuthGuardService} from "@app/core/services/auth.guard";
import {CommonModule, DatePipe, registerLocaleData} from "@angular/common";
import localeAr from "@angular/common/locales/ar";
import {DashboardModule} from "@app/features/dashboard/dashboard.module";
import {ModalModule} from "ngx-bootstrap/modal";
import {OrdersModule} from "@app/features/orders/orders.module";
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {PopoverModule} from "ngx-bootstrap/popover";
import {QRCodeModule} from "angularx-qrcode";
import {RedemptionsModule} from "@app/features/redemptions/redemptions.module";
import {VouchersModule} from "@app/features/vouchers/vouchers.module";
import {SettingsModule} from "@app/features/settings/settings.module";
import { RedemptionPointModule } from './features/redemption-point/redemption-point.module';
import { LocalStorageService } from './core/services/localStorageService';
import { EcommerceModule } from './features/ecommerce/ecommerce.module';

// Angular ships only en-US locale data by default; the store portal defaults to Arabic, so its
// date/number formatting needs the `ar` dataset registered before anything renders.
registerLocaleData(localeAr, 'ar');

@NgModule({
  declarations: [
    AppComponent,
    PortalDefaultRedirectComponent,
  ],
  imports: [
    RouterModule,
    BrowserModule,
    CommonModule,
    DashboardModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    StoreInvitationModule,
    HttpClientModule,
    SharedModule,
    AppTranslateModule,
    OrdersModule,
    SettingsModule,
    VouchersModule,
    EcommerceModule,
    RedemptionsModule,
    RedemptionPointModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    FontAwesomeModule,
    AgmCoreModule.forRoot({
      apiKey: `${environment.googleMapsKey}`
    }),
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    PopoverModule.forRoot(),
    QRCodeModule

  ],
  providers: [
    // First: it must see the request before the token, language and signature are added.
    {
      provide: HTTP_INTERCEPTORS,
      useClass: IdempotencyInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptor,
      multi: true
    },
    AuthService,
    TokenInterceptor,
    RequestInterceptor,
    HttpClient,


    LanguageInterceptor,
    AuthGuardService,
    LocalStorageService,
    I18nService,
    {
      provide: APP_INITIALIZER,
      useFactory: i18nAppInitializer,
      deps: [I18nService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  static injector: Injector;

  constructor(private injector: Injector) {
    AppModule.injector = injector;
  }
}
